<div class="req-page">

  <!-- ── Info banner ── -->
  <div class="org-banner" *ngIf="bannerVisible">
    <mat-icon class="org-banner-icon">info_outline</mat-icon>
    <div class="org-banner-text">
      <strong>Requisitions</strong>
      <p>
        Requisitions are the starting point for organising training engagements.
        Each requisition captures customer details, training schedules, and cloud resource requirements
        before being forwarded for fulfilment.
      </p>
    </div>
    <div class="org-banner-actions">
      <mat-checkbox [(ngModel)]="bannerDismissForever" class="banner-dismiss-check">
        Don't show again
      </mat-checkbox>
      <button mat-icon-button class="banner-close-btn"
              (click)="dismissBanner()"
              matTooltip="Dismiss">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Toolbar -->
  <mat-card class="req-toolbar-card">
    <mat-card-content class="req-toolbar">

      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchTerm" (input)="onSearchChange()"
               placeholder="Enq No, Customer, Training, Status...">
        <mat-icon matPrefix>search</mat-icon>
        <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear"
                (click)="searchTerm=''; onSearchChange()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <span class="toolbar-spacer"></span>

      <button *ngIf="isVisibleAddRequisitionButton"
              mat-raised-button color="primary" (click)="openAddRequisition()">
        <mat-icon>add</mat-icon> New Requisition
      </button>

    </mat-card-content>
  </mat-card>

  <!-- Table -->
  <mat-card class="req-table-card">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <table mat-table [dataSource]="dataSource" matSort class="req-table">

      <!-- Enquiry No Column -->
      <ng-container matColumnDef="enquiryId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Enq No.</th>
        <td mat-cell *matCellDef="let req">
          <span class="enq-no">{{ req?.data?.RequisitionData?.enquiryId || req?.data?.RequisitionData?.docNo }}</span>
        </td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let req">{{ formatDate(req?.data?.RequisitionData?.docDate) }}</td>
      </ng-container>

      <!-- Customer Column -->
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
        <td mat-cell *matCellDef="let req">{{ getCustomerInfo(req?.data?.RequisitionData) }}</td>
      </ng-container>

      <!-- Training Title Column -->
      <ng-container matColumnDef="trainingTitle">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Training</th>
        <td mat-cell *matCellDef="let req" class="training-cell"
            [matTooltip]="getTrainingTitle(req)">
          {{ getTrainingTitle(req) }}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let req">
          <span class="status-badge"
                [ngClass]="getStatusBadgeClass(req?.data?.RequisitionData?.status)">
            <mat-icon class="badge-icon"
                      *ngIf="isPositiveStatus(req?.data?.RequisitionData?.status)">check_circle</mat-icon>
            {{ req?.data?.RequisitionData?.status }}
          </span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-header"></th>
        <td mat-cell *matCellDef="let req" class="actions-cell" (click)="$event.stopPropagation()">
          <button mat-icon-button [matMenuTriggerFor]="reqActionsMenu"
                  aria-label="Actions for this requisition">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #reqActionsMenu="matMenu">
            <button mat-menu-item (click)="openForwardPopup(req)">
              <mat-icon color="primary">share</mat-icon>
              <span>Forward</span>
            </button>
            <button mat-menu-item *ngIf="authService.canArchive()" (click)="archiveRequisition(req)">
              <mat-icon>inventory_2</mat-icon>
              <span>Archive</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="clickable-row"
          (click)="goToDetail(row)"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          <div class="no-data-message">
            <mat-icon>inbox</mat-icon>
            <p>{{ searchTerm ? 'No requisitions match the current filters' : 'No requisitions found' }}</p>
          </div>
        </td>
      </tr>

    </table>

    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" appPersistPageSize="requisitions:list" showFirstLastButtons></mat-paginator>
  </mat-card>

</div>

<!-- Forward Popup -->
<app-forward-requisition *ngIf="showForwardPopup"
  [requisitionId]="selectedRequisition?.id"
  [selectedRequisition]="selectedRequisition"
  (closed)="showForwardPopup=false"
  (forwarded)="onForwarded($event)">
</app-forward-requisition>
